import { SmevRequestActionEnum } from '../enums/SmevRequestActionEnum';
import { ISmevRequestState } from '../interfaces/ISmevRequestState';
import { SmevRequestAction } from '../types/SmevRequestAction';

const initial: ISmevRequestState = {
  smevMessageResponse: undefined,
};

export function smevRequestReducer(state = initial, action: SmevRequestAction) {
  switch (action.type) {
    case SmevRequestActionEnum.SMEV_REQUEST_SET_DATA: {
      const newState: ISmevRequestState = {
        ...state,
        smevMessageResponse: action.payload.data,
      };

      return newState;
    }

    case SmevRequestActionEnum.SMEV_REQUEST_SET_REQUEST_TYPES: {
      const newState: ISmevRequestState = {
        ...state,
        requestType: action.payload.data,
      };

      return newState;
    }

    case SmevRequestActionEnum.SMEV_REQUEST_SET_REQUEST_TEMPLATES: {
      const newState: ISmevRequestState = {
        ...state,
        requestTemplates: action.payload.data,
      };

      return newState;
    }

    default:
      return state;
  }
}
